import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Space } from 'tdesign-react';

import { CardFormComponent, IFormItemProps } from '@/components';
import { PageIds } from '@/const/tip';
import { AigcMusicDialogProps } from '@/material/AigcMusicDialog';
import { orgConfigs } from '@/utils/orgFormConfig';

import { aigcMusicFormCard } from './form-config';
import styles from './index.module.less';

interface AigcMusicInfoProps {
  data: AigcMusicDialogProps['data'];
  getData: (data: IFormData) => void;
}

export interface AigcMusicInfoRef {
  submitForm: () => void;
  getMusicInfo: () => any;
}

export interface IFormData {
  prompt?: string;
  tagChoose?: Record<string, string[]>;
}

const AigcMusicInfo = forwardRef<AigcMusicInfoRef, AigcMusicInfoProps>((props, ref) => {
  const { data, getData } = props;
  const cardFormRef = useRef<any>(null);
  const initData: IFormData = {
    prompt: data?.promptText,
  };
  const [formData, setFormData] = useState<IFormData>(initData);

  useEffect(() => {
    setFormData({ ...formData, prompt: data?.promptText });
    getData({ ...formData, prompt: data?.promptText });
    return () => {
      setFormData({ ...initData });
    };
  }, [data?.promptText]);

  useImperativeHandle(ref, () => ({
    submitForm: handleSave,
    getMusicInfo: () => ({ ...formData }),
  }));

  const onSubmit = async (values: IFormData) => {
    setFormData(values);
  };

  const handleSave = () => {
    cardFormRef.current.formRef.form.submit();
  };

  const onValuesChange = useCallback((content: IFormData) => {
    const newData = { ...formData, ...content };
    getData(newData);
    setFormData(newData);
  }, [formData]);

  const refactorFieldsConfig = (config: IFormItemProps[], values: IFormData) => orgConfigs(config, values, {});

  return (
    <div id="nova-edit-container" className={styles.container} >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <CardFormComponent
          cRef={cardFormRef}
          key={'aigc-music'}
          title={''}
          pageId={PageIds.AIGC_INFO}
          formData={formData}
          fieldsConfig={aigcMusicFormCard.fieldsConfig}
          formConfig={{
            layout: 'vertical',
            labelWidth: '100%',
            labelAlign: 'top',
            onValuesChange,
          }}
          onSubmit={onSubmit}
          extendControlConfig={{
            refactorFieldsConfig: config => refactorFieldsConfig(config, formData),
          }}
        />
      </Space>
    </div>
  );
});

export default AigcMusicInfo;
